export default "__VITE_ASSET__d94d9a10__"